import { ActionReducerMap } from '@ngrx/store';

import { UserConfigurationState } from './user-configuration.declarations';
import { userConfigurationReducer } from './user-configuration.reducer';
import { CalendarConfigurationState } from './calendar-configuration/calendar-configuration.declarations';
import { calendarConfigurationReducer } from './calendar-configuration/calendar-configuration.reducer';

export interface UserConfigurationPartialState {
  userConfiguration: UserConfigurationState;
  calendarConfiguration: CalendarConfigurationState;
}

export const reducers: ActionReducerMap<UserConfigurationPartialState> = {
  userConfiguration: userConfigurationReducer,
  calendarConfiguration: calendarConfigurationReducer
};
